import { makeStyles, Theme } from '@material-ui/core/styles'
import { createStyles, alpha } from '@material-ui/core'

export const useEmptySearchComponentComponentStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      width: '100%',
      textAlign: 'center',
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.shape.borderRadius * 2,
      borderTop: `3px solid ${theme.palette.primary.main}`,
      padding: theme.spacing(4, 3),
      boxSizing: 'border-box',
      boxShadow: 'none',
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(3, 2),
      },
    },
    inner: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: theme.spacing(2.5),
    },
    iconWrap: {
      width: 88,
      height: 88,
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      backgroundColor: alpha(theme.palette.primary.main, 0.12),
    },
    icon: {
      fontSize: 40,
      color: theme.palette.primary.main,
    },
    title: {
      fontWeight: 700,
      fontSize: '1.25rem',
      lineHeight: 1.3,
      color: theme.palette.text.primary,
      margin: 0,
      [theme.breakpoints.down('sm')]: {
        fontSize: '1.125rem',
      },
    },
    description: {
      margin: 0,
      fontSize: '0.9375rem',
      lineHeight: 1.6,
      color: theme.palette.text.secondary,
      maxWidth: 420,
    },
  })
)
